export const FIELDS = {

  ID: 'id',
  ITEM_CATEGORY_TYPE: 'itemCategoryType',
  NAME: 'name',
  SYNC_TOKEN: 'syncToken',
  INV_START_DATE: 'invStartDate',
  TYPE: 'type',
  QTY_ON_HAND: 'qtyOnHand',
  ASSET_ACCOUNT_REF_NAME: 'assetAccountRefName',
  ASSET_ACCOUNT_REF_VALUE: 'assetAccountRefValue',
  SKU: 'sku',
  SALES_TAX_INCLUDED: 'salesTaxIncluded',
  TRACK_QTY_ON_HAND: 'trackQtyOnHand',
  SALES_TAX_CODE_REF_NAME: 'salesTaxCodeRefName',
  SALES_TAX_CODE_REF_VALUE: 'salesTaxCodeRefValue',
  CLASS_REF_NAME: 'classRefName',
  CLASS_REF_VALUE: 'classRefValue',
  PURCHASE_TAX_INCLUDED: 'purchaseTaxIncluded',
  DESCRIPTION: 'description',
  ABATEMENT_RATE: 'abatementRate',
  REVERSE_CHARGE_RATE: 'reverseChargeRate',
  SUB_ITEM: 'subItem',
  TAXABLE: 'taxable',
  UQCDISPLAY_TEXT: 'uqcDisplayText',
  REORDER_POINT: 'reorderPoint',
  PURCHASE_DESC: 'purchaseDesc',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  PREF_VENDOR_REF_NAME: 'prefVendorRefName',
  PREF_VENDOR_REF_VALUE: 'prefVendorRefValue',
  ACTIVE: 'active',
  UQCID: 'uqcId',
  PURCHASE_TAX_CODE_REF_NAME: 'purchaseTaxCodeRefName',
  PURCHASE_TAX_CODE_REF_VALUE: 'purchaseTaxCodeRefValue',
  SERVICE_TYPE: 'serviceType',
  PURCHASE_COST: 'purchaseCost',
  PARENT_REF_NAME: 'parentRefName',
  PARENT_REF_VALUE: 'parentRefValue',
  UNIT_PRICE: 'unitPrice',
  FULLY_QUALIFIED_NAME: 'fullyQualifiedName',
  LEVEL: 'level',
  INCOME_ACCOUNT_REF_NAME: 'incomeAccountRefName',
  INCOME_ACCOUNT_REF_VALUE: 'incomeAccountRefValue',
  EXPENSE_ACCOUNT_REF_NAME: 'expenseAccountRefName',
  EXPENSE_ACCOUNT_REF_VALUE: 'expenseAccountRefValue',
  TAX_CLASSIFICATION_REF_NAME: 'taxClassificationRefName',
  TAX_CLASSIFICATION_REF_VALUE: 'taxClassificationRefValue',
};